const PASTAEL_TRAVEL_CLUB_POPUP_STORAGE_KEY = 'pastael-travel-club-popup-last-shown';

function initPastaelTravelClubPopupOverlayClose(popup) {
  if (!popup || popup.pastaelOverlayCloseInit) return;

  const desktopMediaQuery = window.matchMedia('(min-width: 750px)');
  const overlay = popup.querySelector('[data-travel-club-popup-overlay]');
  if (!overlay) return;

  popup.pastaelOverlayCloseInit = true;

  const hideOverlayClose = () => {
    overlay.classList.remove('is-pointer-active');
    const closeButton = overlay.querySelector('[data-overlay-close]');
    if (closeButton) closeButton.hidden = true;
  };

  popup.addEventListener('mousemove', (event) => {
    if (!desktopMediaQuery.matches || popup.hidden) {
      hideOverlayClose();
      return;
    }

    const closeButton = overlay.querySelector('[data-overlay-close]');
    if (!closeButton) return;

    const panel = popup.querySelector('.pastael-travel-club-popup__panel');
    if (panel?.contains(event.target)) {
      hideOverlayClose();
      return;
    }

    const onOverlay =
      event.target === overlay || event.target === closeButton || overlay.contains(event.target);
    if (!onOverlay) {
      hideOverlayClose();
      return;
    }

    overlay.classList.add('is-pointer-active');
    closeButton.hidden = false;

    const bounds = overlay.getBoundingClientRect();
    closeButton.style.left = `${event.clientX - bounds.left}px`;
    closeButton.style.top = `${event.clientY - bounds.top}px`;
  });

  popup.addEventListener('mouseleave', hideOverlayClose);

  overlay.addEventListener('click', (event) => {
    if (event.target.closest('.pastael-travel-club-popup__panel')) return;
    if (event.target.closest('[data-overlay-close]')) return;
    popup.close?.();
  });

  popup.addEventListener('click', (event) => {
    if (!event.target.closest('[data-overlay-close]')) return;
    event.preventDefault();
    event.stopPropagation();
    popup.close?.();
    hideOverlayClose();
  });

  desktopMediaQuery.addEventListener('change', hideOverlayClose);
}

function pastaelTravelClubPopupCanShow(frequencyDays) {
  try {
    const lastShown = localStorage.getItem(PASTAEL_TRAVEL_CLUB_POPUP_STORAGE_KEY);
    if (!lastShown) return true;
    const elapsed = Date.now() - Number(lastShown);
    const intervalMs = frequencyDays * 24 * 60 * 60 * 1000;
    return elapsed >= intervalMs;
  } catch (error) {
    return true;
  }
}

function pastaelTravelClubPopupRememberShown() {
  try {
    localStorage.setItem(PASTAEL_TRAVEL_CLUB_POPUP_STORAGE_KEY, String(Date.now()));
  } catch (error) {}
}

function pastaelTravelClubPopupShouldBlockAutoOpen() {
  if (document.documentElement.classList.contains('shopify-design-mode')) return true;
  const template = document.querySelector('main[data-template]')?.dataset.template || '';
  if (template === 'password' || template === 'gift_card') return true;
  if (document.querySelector('pastael-gift-popup dialog[open], pastael-gift-popup[data-pending-auto-open]')) {
    return true;
  }
  const cartDrawer = document.querySelector('cart-drawer.pastael-cart-drawer');
  if (cartDrawer?.classList.contains('active')) return true;
  return false;
}

if (!customElements.get('pastael-travel-club-popup')) {
  customElements.define(
    'pastael-travel-club-popup',
    class PastaelTravelClubPopup extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-travel-club-popup-overlay]');
        this.autoOpenTimer = null;

        this.onCloseClick = this.onCloseClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onFormSuccess = this.onFormSuccess.bind(this);

        this.querySelector('[data-travel-club-popup-close]')?.addEventListener('click', this.onCloseClick);
        document.addEventListener('keydown', this.onKeydown);

        initPastaelTravelClubPopupOverlayClose(this);

        const successMessage = this.querySelector('.pastael-travel-club__message--success');
        if (successMessage) {
          this.open();
          return;
        }

        this.scheduleAutoOpen();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKeydown);
        if (this.autoOpenTimer) window.clearTimeout(this.autoOpenTimer);
      }

      get delaySeconds() {
        return Number(this.dataset.delaySeconds || 5);
      }

      get frequencyDays() {
        return Number(this.dataset.frequencyDays || 7);
      }

      scheduleAutoOpen() {
        if (pastaelTravelClubPopupShouldBlockAutoOpen()) return;
        if (!pastaelTravelClubPopupCanShow(this.frequencyDays)) return;

        const delayMs = Math.max(3, Math.min(15, this.delaySeconds)) * 1000;
        this.autoOpenTimer = window.setTimeout(() => {
          if (pastaelTravelClubPopupShouldBlockAutoOpen()) return;
          this.open();
        }, delayMs);
      }

      onCloseClick(event) {
        event.preventDefault();
        this.close();
      }

      onKeydown(event) {
        if (event.key !== 'Escape' || this.hidden) return;
        this.close();
      }

      onFormSuccess() {
        this.close();
      }

      open() {
        if (!this.hasAttribute('hidden')) return;

        this.hidden = false;
        this.removeAttribute('hidden');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
        pastaelTravelClubPopupRememberShown();

        this.querySelector('[data-travel-club-popup-close]')?.focus();
      }

      close() {
        if (this.hasAttribute('hidden')) return;

        this.hidden = true;
        this.setAttribute('hidden', '');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
        pastaelTravelClubPopupRememberShown();

        this.overlay?.classList.remove('is-pointer-active');
        const overlayClose = this.overlay?.querySelector('[data-overlay-close]');
        if (overlayClose) overlayClose.hidden = true;
      }
    }
  );
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.closest('pastael-travel-club-popup')) return;

  window.setTimeout(() => {
    const popup = form.closest('pastael-travel-club-popup');
    if (popup?.querySelector('.pastael-travel-club__message--success')) {
      popup.close?.();
    }
  }, 100);
});
